<template>
  <div class="striped-list__row">
    <b-row class="align-items-center">
      <b-col class="d-flex align-items-center">
        <b-form-checkbox v-model="selected" class="d-block w-100" @change="checkSelection">
          {{ licenceArea.name }} ({{ licenceArea.code }})<br />
          <small v-if="selectedZones && selectedZones.length">
            Selected zones:<br />
            <template v-for="(zone, index) in selectedZones">
              <template v-if="index !== 0">, </template>
              <template v-if="zone.name"> {{ zone.name }} ({{ zone.code }}) </template>
              <template v-else>
                {{ zone.code }}
              </template>
            </template>
          </small>
        </b-form-checkbox>
      </b-col>
      <b-col cols="auto" class="text-right striped-list__actions">
        <b-button
          v-if="zones.length"
          variant="rounded"
          :disabled="!selected"
          @click="showModal = true"
        >
          Zones
        </b-button>
      </b-col>
    </b-row>
    <ZonesList :show="showModal" :zones="zones" @save="saveZones" @hide="hideModal" />
  </div>
</template>

<script>
import ZonesList from './zones-list';

export default {
  name: 'LicenceArea',
  components: { ZonesList },
  props: ['licenceArea', 'name', 'value'],
  data() {
    return {
      selected: this.value,
      showModal: false
    };
  },
  computed: {
    zones() {
      return this.licenceArea ? this.licenceArea.zones : [];
    },
    selectedZones() {
      return this.licenceArea && this.licenceArea.zones.filter(zone => zone.selected);
    }
  },
  watch: {
    value(value) {
      this.selected = value;
    }
  },
  methods: {
    checkSelection(checked) {
      this.$set(this.licenceArea, 'selected', checked);

      this.licenceArea.zones.forEach((zone, zIndex) => {
        this.$set(this.licenceArea.zones, zIndex, { ...zone, selected: checked });
      });
    },
    hideModal() {
      this.showModal = false;
    },
    saveZones(selectedZones) {
      this.hideModal();
      this.$set(this.licenceArea, 'zones', selectedZones);

      if (!this.licenceArea.zones.filter(zone => zone.selected).length) {
        this.$set(this.licenceArea, 'selected', false);
      }
    }
  }
};
</script>
